import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ReactComponent as AddIcon } from 'assets/icons/addIcon.svg';
import { GoBackButtonWithTitle } from 'components';
import { CreateButton } from 'features/documentCategories/components/DocumentCategories/styled';
import { Links } from 'settings';
import { theme } from 'styles';

import { PageHeaderW } from './styled';

export function PageHeader(): ReactElement {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <PageHeaderW>
      <GoBackButtonWithTitle title={t('tasks.tasksManagement.pageTitle')} />
      <CreateButton
        startIcon={<AddIcon style={{ fill: '#fff' }} />}
        onClick={() => navigate(Links.profile.createTask)}
        style={{
          height: '56px',
          width: '250px',
          padding: '8px',
          marginRight: '8px',
          backgroundColor: theme.palette.info.main,
          color: theme.palette.common.white,
          fontSize: '14px',
          fontWeight: 400,
          borderRadius: '8px',
          textTransform: 'none',
        }}
      >
        {t('tasks.addNewTask')}
      </CreateButton>
    </PageHeaderW>
  );
}
